import Vue from 'vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

Vue.directive('transfer-dom', TransferDom)
import XButton from 'vux/src/components/x-button/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'


Vue.component('x-button', XButton)
Vue.component('icon', Icon)

Vue.component('divider', Divider)
Vue.component('flexbox', Flexbox)
Vue.component('flexbox-item', FlexboxItem)
Vue.component('grid', Grid)
Vue.component('grid-item', GridItem)
Vue.component('sticky', Sticky)
Vue.component('view-box', ViewBox)


import Calendar from 'vux/src/components/calendar/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'
import DatetimeView from 'vux/src/components/datetime-view/index.vue'
import DatetimeRange from 'vux/src/components/datetime-range/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import Group from 'vux/src/components/group/index.vue'
import InlineXSwitch from 'vux/src/components/inline-x-switch/index.vue'
import InlineXNumber from 'vux/src/components/inline-x-number/index.vue'
import InlineCalendar from 'vux/src/components/inline-calendar/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Rater from 'vux/src/components/rater/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Range from 'vux/src/components/range/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import Search from 'vux/src/components/search/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'


Vue.component('calendar', Calendar)
Vue.component('cell-form-preview', CellFormPreview)
Vue.component('cell', Cell)
Vue.component('check-icon', CheckIcon)
Vue.component('checker', Checker)
Vue.component('checker-item', CheckerItem)
Vue.component('checklist', Checklist)
Vue.component('datetime-view', DatetimeView)
Vue.component('datetime-range', DatetimeRange)
Vue.component('datetime', Datetime)
Vue.component('form-preview', FormPreview)
Vue.component('group', Group)
Vue.component('inline-x-switch', InlineXSwitch)
Vue.component('inline-x-number', InlineXNumber)
Vue.component('inline-calendar', InlineCalendar)
Vue.component('popup-picker', PopupPicker)
Vue.component('popup-radio', PopupRadio)
Vue.component('picker', Picker)
Vue.component('rater', Rater)
Vue.component('radio', Radio)
Vue.component('range', Range)
Vue.component('selector', Selector)
Vue.component('swipeout', Swipeout)
Vue.component('swipeout-item', SwipeoutItem)
Vue.component('swipeout-button', SwipeoutButton)
Vue.component('search', Search)
Vue.component('x-switch', XSwitch)
Vue.component('x-input', XInput)
Vue.component('x-number', XNumber)
Vue.component('x-textarea', XTextarea)
Vue.component('x-address', XAddress)

import Badge from 'vux/src/components/badge/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Clocker from 'vux/src/components/clocker/index.vue'
import Countup from 'vux/src/components/countup/index.vue'
import Flow from 'vux/src/components/flow/flow.vue'
import FlowState from 'vux/src/components/flow/flow-state.vue'
import FlowLine from 'vux/src/components/flow/flow-line.vue'
import Marquee from 'vux/src/components/marquee/marquee.vue'
import MarqueeItem from 'vux/src/components/marquee/marquee-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'
import Step from 'vux/src/components/step/step.vue'
import StepItem from 'vux/src/components/step/step-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'
import XImg from 'vux/src/components/x-img/index.vue'


Vue.component('badge', Badge)
Vue.component('card', Card)
Vue.component('clocker', Clocker)
Vue.component('countup', Countup)
Vue.component('flow', Flow)
Vue.component('flow-state', FlowState)
Vue.component('flow-line', FlowLine)
Vue.component('marquee', Marquee)
Vue.component('marquee-item', MarqueeItem)
Vue.component('panel', Panel)
Vue.component('previewer', Previewer)
Vue.component('qrcode', Qrcode)
Vue.component('step', Step)
Vue.component('step-item', StepItem)
Vue.component('swiper', Swiper)
Vue.component('x-table', XTable)
Vue.component('x-progress', XProgress)
Vue.component('x-img', XImg)

import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Msg from 'vux/src/components/msg/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popover from 'vux/src/components/popover/index.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'


Vue.component('actionsheet', Actionsheet)
Vue.component('confirm', Confirm)
Vue.component('inline-loading', InlineLoading)
Vue.component('load-more', LoadMore)
Vue.component('loading', Loading)
Vue.component('msg', Msg)
Vue.component('popup', Popup)
Vue.component('popup-header', PopupHeader)
Vue.component('popover', Popover)
Vue.component('spinner', Spinner)
Vue.component('toast', Toast)
Vue.component('x-dialog', XDialog)

import ButtonTab from 'vux/src/components/button-tab/button-tab.vue'
import ButtonTabItem from 'vux/src/components/button-tab/button-tab-item.vue'
import Drawer from 'vux/src/components/drawer/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'


Vue.component('button-tab', ButtonTab)
Vue.component('button-tab-item', ButtonTabItem)
Vue.component('drawer', Drawer)
Vue.component('tab', Tab)
Vue.component('tab-item', TabItem)
Vue.component('tabbar', Tabbar)
Vue.component('tabbar-item', TabbarItem)
Vue.component('x-header', XHeader)


import Timeline from 'vux/src/components/timeline/timeline.vue'


import VChart from 'vux/src/components/v-chart/v-chart.vue'
import VLine from 'vux/src/components/v-chart/v-line.vue'
import VArea from 'vux/src/components/v-chart/v-area.vue'
import VBar from 'vux/src/components/v-chart/v-bar.vue'
import VPie from 'vux/src/components/v-chart/v-pie.vue'
import VPoint from 'vux/src/components/v-chart/v-point.vue'
import VScale from 'vux/src/components/v-chart/v-scale.vue'
import VAxis from 'vux/src/components/v-chart/v-axis.vue'
import VGuide from 'vux/src/components/v-chart/v-guide.vue'
import VTooltip from 'vux/src/components/v-chart/v-tooltip.vue'
import VLegend from 'vux/src/components/v-chart/v-legend.vue'


Vue.component('v-chart', VChart)
Vue.component('v-line', VLine)
Vue.component('v-area', VArea)
Vue.component('v-bar', VBar)
Vue.component('v-pie', VPie)
Vue.component('v-point', VPoint)
Vue.component('v-scale', VScale)
Vue.component('v-axis', VAxis)
Vue.component('v-guide', VGuide)
Vue.component('v-tooltip', VTooltip)
Vue.component('v-legend', VLegend)


import XCircle from 'vux/src/components/x-circle/index.vue'

Vue.component('x-circle', XCircle)


Vue.component('timeline', Timeline)
export default ({})



// WEBPACK FOOTER //
// ./src/vux/index.js